module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IGp9qm/tc-custom/9781788854498.jpg?1704294272496",
      "alt": "This image is the cover for the book Last Wild Place"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Wild Place\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Mike Tomkies moved to a remote cottage on the shores of Loch Shiel in the West Highlands of Scotland, he found a place which was to provide him with the most profound wilderness experience of his life. Accessible only by boat, the cottage he renamed ‘Wildernesse’ was to be his home for many years, which he shared with his beloved German Shepherd, Moobli.  Centred on different landscape elements – loch, woodlands and mountains –Tomkies describes the whole cycle of nature through the seasons in a harsh and testing environment of unrivalled beauty. Vivid colours and sounds fill the pages – exotic wild orchids, the roar of rutting stags, the territorial movements of foxes, otters and badgers, an oak tree being torn apart by hurricane-force gales. Nothing escapes his penetrating eye.  His extraordinary insights into the wildlife that shared his otherwise empty territory were not gained without perseverance in the face of perilous hazards, and the difficulties and challenges of life in the wilderness are a key part of this remarkable book.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mike Tomkies\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Jonathan Cape\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0